"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const BorderedIcon_1 = tslib_1.__importDefault(require("../ui/BorderedIcon/BorderedIcon"));
const ClusterProgressItem = ({ icon, children, }) => (react_1.default.createElement(react_core_1.Stack, null,
    react_1.default.createElement(react_core_1.StackItem, null,
        react_1.default.createElement(BorderedIcon_1.default, null, icon)),
    react_1.default.createElement(react_core_1.StackItem, null,
        react_1.default.createElement(react_core_1.TextContent, null, children))));
exports.default = ClusterProgressItem;
//# sourceMappingURL=ClusterProgressItem.js.map